import { useEffect, useState } from "react";
import api from "../lib/api";
import { LandingHeader, HeroSection } from "../components/landing/Hero";
import { RoomsShowcase } from "../components/landing/RoomsShowcase";
import { FeaturesSection } from "../components/landing/FeaturesSection";

export default function Landing() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/public/availability").then((r) => setData(r.data)).catch(() => setData({ properties: [] }));
  }, []);

  return (
    <div className="min-h-screen bg-white text-[#0b1220]">
      <LandingHeader />
      <HeroSection propertyCount={data?.properties?.length} />
      <RoomsShowcase data={data} />
      <FeaturesSection />
      <footer className="py-10 bg-[#0b1220] text-slate-500 text-sm border-t border-slate-800" data-testid="landing-footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 flex justify-center">
          <div>© 2026 StayCare Services. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
}
